import { LOAD_GLOBAL_BANK_LIST, SET_GLOBAL_BANK_LIST } from 'state/actionTypes';

export const setGlobalBankList = banks => ({
  type: SET_GLOBAL_BANK_LIST,
  payload: { banks },
});

export const loadGlobalBankList = () => ({
  type: LOAD_GLOBAL_BANK_LIST,
});
